document.addEventListener('DOMContentLoaded', () => {
  const reduced =
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const body = document.body;
  const root = document.documentElement;

  function q(selector, scope) {
    return (scope || document).querySelector(selector);
  }
  function qa(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }
   var reveals = qa(".dhs-reveal");
    if (reduced) {
      reveals.forEach(function (element) {
        element.classList.add("is-revealed");
      });
      return;
    }
    if (window.gsap && window.ScrollTrigger) {
      window.gsap.registerPlugin(window.ScrollTrigger);
      reveals.forEach(function (element) {
        window.gsap.fromTo(
          element,
          { opacity: 0, y: 30 },
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
            ease: "power3.out",
            scrollTrigger: { trigger: element, start: "top 87%", once: true },
            onStart: function () {
              element.classList.add("is-revealed");
            }
          }
        );
      });
      window.gsap.to(".hero-word", {
        xPercent: -6,
        ease: "none",
        scrollTrigger: {
          trigger: ".dhs-hero-trigger",
          start: "top top",
          end: "bottom top",
          scrub: 0.6
        }
      });
    } else if ("IntersectionObserver" in window) {
      var revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add("is-revealed");
              revealObserver.unobserve(entry.target);
            }
          });
        },
        { rootMargin: "0px 0px -10% 0px", threshold: 0.08 }
      );
      reveals.forEach(function (element) {
        revealObserver.observe(element);
      });
    } else {
      reveals.forEach(function (element) {
        element.classList.add("is-revealed");
      });
    }
});
